export default __webpack_public_path__ + "static/media/photo--lg--misc-23.f0c0be8f.jpg";